import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ResultComponent } from './result/result.component';
import { SearchByLocationComponent } from './search-by-location/search-by-location.component';
import { SearchResultsLocationComponent } from './search-results-location/search-results-location.component';
import { SearchLocationNoResultsComponent } from './search-location-no-results/search-location-no-results.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'result', component: ResultComponent },
  { path: 'search-by-location', component: SearchByLocationComponent },
  { path: 'search-results-location', component: SearchResultsLocationComponent },
  { path: 'search-location-no-results', component: SearchLocationNoResultsComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
